import React from 'react'
import { FieldNames } from 'Constants/FieldNames'
import { TextAreaComponent } from 'LibNeo'
import { WrappedFormUtils } from 'antd/lib/form/Form'
import { Validators } from 'Modules'
import { clearSpecialCharacters } from 'Helpers'
import { useBgDict } from 'Pages/ibro'

interface ComponentProps<T> {
	fieldName: FieldNames
	form: WrappedFormUtils
	item: T
	onChange?: (string) => void
	required?: boolean
	maxLength?: number
	initialValue?: string
}

export const BgTextArea = <
	T extends { required_fields: FieldNames[]; locked_fields: FieldNames[] }
>({
	form,
	fieldName,
	item,
	required,
	onChange,
	maxLength,
	initialValue,
}: ComponentProps<T>) => {
	const { allowedSymbols } = useBgDict()

	const { required_fields, locked_fields } = item
	const onPressEnter = (e: React.FormEvent<EventTarget>) => {
		e.preventDefault()
	}

	const isLocked = locked_fields.includes(fieldName)

	return (
		<TextAreaComponent
			form={form}
			fieldName={fieldName}
			onChange={onChange}
			onPressEnter={onPressEnter}
			required={required_fields.includes(fieldName)}
			fieldOptions={{
				rules: isLocked
					? []
					: [
							maxLength
								? {
										validator: Validators.checkMaxLength({
											payload: { max: maxLength },
										}),
								  }
								: {},
							allowedSymbols
								? {
										validator: Validators.checkInvalidCharacters({
											required: required || required_fields.includes(fieldName),
											payload: {
												allowSymbols: allowedSymbols,
											},
										}),
								  }
								: {},
					  ],
				initialValue: initialValue || undefined,
				normalize: clearSpecialCharacters,
			}}
			isTrimData
		/>
	)
}
